// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface FileCopyIconSignature {
  Element: SVGSVGElement;
}

export const FileCopyIcon: TOC<FileCopyIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.414 1H9C7.897 1 7 1.898 7 3V17C7 18.103 7.897 19 9 19H19C20.103 19 21 18.103 21 17V5.586L16.414 1ZM19.001 17H9V3H15V7H19L19.001 17ZM3 5H5V21H17V23H5C3.897 23 3 22.103 3 21V5Z"/>
</svg>
</template>;